type WorkloadAdjustmentError = {
  forbidden: boolean;
  notFound: boolean;
};

const workloadAdjustmentError: WorkloadAdjustmentError = {
  forbidden: false,
  notFound: false,
};

export type { WorkloadAdjustmentError };

export { workloadAdjustmentError };
